import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import ReplayIcon from '@mui/icons-material/Replay';
import { Tooltip } from '@mui/material';

import { formatTaxId } from '../../../../services/format';

import '../../../../style.css';

function ListRows({
  partner, setSelectedPartner, handleConfirmRemovePartner, handleConfirmActivatePartner,
}) {
  return (
    <>
      <tr
        key={partner.id}
        className='table-rows-component-tr'
      >
        <td
          className='table-rows-component-td table-rows-component-first-column'
          onClick={() => setSelectedPartner(partner)}
        >
          {partner.name}
        </td>
        <td
          className='table-rows-component-td text-center'
          onClick={() => setSelectedPartner(partner)}
        >
          {partner.partnerCode}
        </td>
        <td
          className='table-rows-component-td text-center'
          onClick={() => setSelectedPartner(partner)}
        >
          {partner.taxId ? formatTaxId(partner.taxId, 'cpf') : '-'}
        </td>
        <td
          className='table-rows-component-td text-center'
          onClick={() => setSelectedPartner(partner)}
        >
          {partner.phones.map((phone) => (
            <div>{phone}</div>
          ))}
        </td>
        <td
          className='table-rows-component-td'
          onClick={() => setSelectedPartner(partner)}
        >
          {partner.email}
        </td>
        <td
          className='table-rows-component-td'
          onClick={() => setSelectedPartner(partner)}
        >
          {partner.location}
        </td>
        <td
          className='table-rows-component-td text-center'
          onClick={() => setSelectedPartner(partner)}
        >
          {partner.active ? 'Ativo' : 'Inativo'}
        </td>
        <td
          className='table-rows-component-buttons-cell table-rows-component-last-column'
          style={{
            display: 'table-cell',
            verticalAlign: 'middle',
            paddingLeft: 12,
          }}
        >
          {partner.active ? (
            <span
              className='table-buttons'
              onClick={() => handleConfirmRemovePartner(partner)}
            >
              <Tooltip title='Excluir/Inativar'>
                <DeleteForeverIcon style={{ color: 'red' }} />
              </Tooltip>
            </span>
          ) : (
            <span
              className='table-buttons activate-button'
              onClick={() => handleConfirmActivatePartner(partner)}
            >
              <Tooltip title='Reativar'>
                <ReplayIcon style={{ color: 'green' }} />
              </Tooltip>
            </span>
          )}
        </td>
      </tr>
    </>
  );
}

export default ListRows;
